export default "__VITE_PUBLIC_ASSET__f7762bd0__"